module.exports = __webpack_public_path__ + "img/bgtop.b6b7f041.png";